import React from 'react';

function About() {
  return <div className="about">Your About Details go Here!</div>;
}

export default About;
